import { useEffect, useState } from "react";

function About() {
  const [ctaVisible, setCtaVisible] = useState(false);

  useEffect(() => {
    const boxes = document.querySelectorAll(".about-box");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    boxes.forEach((box) => observer.observe(box));

    // Calculate when to show CTA:
    const delayStep = 150; // must match your map()
    const numBoxes = boxes.length;
    const boxDuration = 800; // matches CSS transition

    // total = longest delay + duration
    const totalTime = (numBoxes - 1) * delayStep + boxDuration;

    const timer = setTimeout(() => {
      setCtaVisible(true);
    }, totalTime);

    return () => clearTimeout(timer);
  }, []);

  const delayStep = 150;

  return (
    <>
      <section className="about-section bg-default text-center" id="about">
        <div className="container px-4 px-lg-5">

          {/* === HERO === */}
          <div className="mb-5">
            <h1 className="text-white mb-3 big-title">
              CGT Made Hassle-Free.
            </h1>
            <p className="text-white-80 mb-0 lead mt-2">
              Your trusted partner for stress-free Capital Gains Tax compliance and savings.
            </p>
          </div>

          {/* === TRUST BOXES === */}
          <div className="row gx-5 gy-4 text-start">
            {[
              {
                title: "✔️ Decades of Expertise",
                text:
                  "ACCA-accredited accountants with 20+ years of CGT expertise. We keep your submissions precise, on time, and fully compliant — so you can relax.",
              },
              {
                title: "💡 Maximum Reliefs",
                text:
                  "We check all possible exemptions, Private Residence Relief and other allowances to minimise your CGT bill legally and efficiently.",
              },
              {
                title: "🔒 Private & Secure",
                text:
                  "All your tax data stays confidential. We use bank-level encryption, no third-party sharing, and secure cloud systems for peace of mind.",
              },
              {
                title: "📞 Clear Support",
                text:
                  "Friendly UK-based experts explain your tax in plain English — with updates at every step, plus phone & email support when you need us.",
              },
              {
                title: "✅ Accuracy Promise",
                text:
                  "We double-check your figures, so your return is error-free. If there's an issue due to us, we fix it promptly at no extra cost.",
              },
              {
                title: "⚡ Fast Turnaround",
                text:
                  "From simple sales to complex property chains, your CGT is filed fast — avoiding penalties & last-minute panic.",
              },
            ].map((item, i) => (
              <div className="col-lg-4" key={i}>
                <div
                  className="about-box p-4 h-100"
                  style={{ transitionDelay: `${i * delayStep}ms` }}
                >
                  <h4 className="text-white mb-2 fw-bold">{item.title}</h4>
                  <p className="text-white-80 mb-0">{item.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* === CTA === */}
          <div className={`about-cta mt-5 ${ctaVisible ? "show" : ""}`}>
            <h5 className="text-white mb-3">
            Rest Easy—We Handle Your CGT
            </h5>
            <p className="cta-text mb-4">
            Accurate filings in 60 days, so you can focus on what matters most.
  </p>
            <a
              href="https://chatcgt.typeform.com/to/rUw4Egui"
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary px-4 py-3"
            >
              Get Started Now
            </a>
          </div>

        </div>
      </section>
    </>
  );
}

export default About;
